import React from "react";
import { Bar } from "react-chartjs-2";
import { chartTooltip } from "Components/Charts";
import { ReactifyChartColors } from "Util/ReactifyChartColors";

const colors = ReactifyChartColors();

const chartData = {
  labels: ["January", "February", "March", "April", "May", "June", "July"],
  datasets: [
    {
      label: "Sales",
      backgroundColor: colors.foregroundColor,
      borderColor: colors.ReactifyChartColor1,
      borderWidth: 2,
      hoverBackgroundColor: colors.foregroundColor,
      hoverBorderColor: colors.ReactifyChartColor1,
      data: [65, 59, 80, 81, 56, 55, 70]
    }
  ]
};

const chartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  tooltips: chartTooltip,
  plugins: {
    datalabels: {
      display: false
    }
  }
};

function BarChart() {
  return (
    <div>
      <Bar data={chartData} options={chartOptions} />
    </div>
  );
}

export default BarChart;
